import { AsyncPipe } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CheckboxComponent, FormInputComponent, UntypedFormComponent } from '@ftr/forms'
import {
  DividerComponent,
  FocusableNoopAnchorDirective,
  IllustrationComponent,
  NotificationModule,
  PageComponent,
} from '@ftr/foundation'
import { LoginModule } from '../login-module'
import { SingleSignOnModule } from '../single-sign-on'
import { ConfirmationSentComponent } from './confirmation-sent/confirmation-sent.component'
import { SignupAttributesService } from './signup-attributes.service'
import { SignupComponent } from './signup/signup.component'

@NgModule({
  imports: [
    RouterModule,
    LoginModule,
    SingleSignOnModule,
    IllustrationComponent,
    CheckboxComponent,
    DividerComponent,
    PageComponent,
    NotificationModule,
    UntypedFormComponent,
    FormInputComponent,
    FocusableNoopAnchorDirective,
    AsyncPipe,
  ],
  declarations: [SignupComponent, ConfirmationSentComponent],
  providers: [SignupAttributesService],
  exports: [SignupComponent, ConfirmationSentComponent],
})
export class SignupModule {}
